import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {SetPasswordComponent} from "./set-password.component";
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [SetPasswordComponent],
    imports     : [BrowserModule, ReactiveFormsModule],
})

export class SetPasswordModule {}


// WEBPACK FOOTER //
// ./src/app/views/set-password/set-password.module.ts